module.exports = __webpack_public_path__ + "static/media/Rossmann_Regular_Italic.d2e5291e.woff2";